<template>
  <div class="demand-insights-text">
    <ul class="mb-0 pl-3">
      <li
        v-for="(item, idx) in summaryItems"
        :key="idx"
        class="mb-1 small"
      >
        {{ item }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'DemandInsightsText',

  props: {
    insight: {
      type: Object,
      default: null
    }
  },

  computed: {
    summaryItems() {
      if (!this.insight?.schedule?.length) {
        return []
      }

      return this.insight.schedule.map(schedule => {
        const parts = []

        if (schedule.isAllHours) {
          parts.push('24/7')
        } else if (schedule.dailySchedule) {
          parts.push(this.formatDailySchedule(schedule.dailySchedule))
        }

        if (schedule.location) {
          if (schedule.location.isNationwide) {
            parts.push('Nationwide')
          } else if (schedule.location.states?.length) {
            parts.push(schedule.location.states.join(', '))
          }
        }

        if (schedule.trafficSourceNames?.length) {
          parts.push(schedule.trafficSourceNames.join(', '))
        }

        return parts.join(' | ')
      })
    }
  },

  methods: {
    formatDailySchedule(dailySchedule) {
      if (!dailySchedule?.length) {
        return 'N/A'
      }

      const dayNames = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
      const scheduleMap = {}

      dailySchedule.forEach((day, idx) => {
        if (idx >= dayNames.length) {
          return
        }

        const dayName = dayNames[idx]
        if (day.isClosed) {
          scheduleMap[dayName] = 'Closed'
        } else if (day.openTime && day.closeTime) {
          const open = `${day.openTime.hour.toString().padStart(2, '0')}:${day.openTime.minute.toString().padStart(2, '0')}`
          const close = `${day.closeTime.hour.toString().padStart(2, '0')}:${day.closeTime.minute.toString().padStart(2, '0')}`
          scheduleMap[dayName] = `${open}-${close}`
        }
      })

      const groups = []
      let currentGroup = { days: [], schedule: null }

      dayNames.forEach(day => {
        const sched = scheduleMap[day]
        if (sched === currentGroup.schedule) {
          currentGroup.days.push(day)
        } else {
          if (currentGroup.days.length > 0) {
            groups.push({ ...currentGroup })
          }

          currentGroup = { days: [day], schedule: sched }
        }
      })
      if (currentGroup.days.length > 0) {
        groups.push(currentGroup)
      }

      return groups.map(g => {
        const dayRange = g.days.length > 1
          ? `${g.days[0]}-${g.days[g.days.length - 1]}`
          : g.days[0]
        return `${dayRange}: ${g.schedule}`
      }).join(', ')
    }
  }
}
</script>
